const expanderButton = document.getElementById('social_expander_buton');
// const isTransitioning = null;

const init = function() {

  setupShareExpander();

};


const setupShareExpander = function() {

  if ( expanderButton ) {

    const parent = expanderButton.parentElement;

    expanderButton.addEventListener( 'click', () => {
      if ( parent.classList.contains( 'is-expanded' ) ) {
        contract( expanderButton, parent );
      } else {
        expand( expanderButton, parent );
      }
    } );
  }

};


const expand = function( button, parent ) {

  parent.classList.add( 'is-expanded' );

  setTimeout( () => {
    button.setAttribute( 'aria-expanded', 'true' );
    parent.classList.add( 'do-transition' )
  }, 10 );

}


const contract = function( button, parent ) {
  
  parent.classList.remove( 'do-transition' );

  setTimeout( () => {
    button.setAttribute( 'aria-expanded', 'false' );
    parent.classList.remove( 'is-expanded' )
  }, 250 );

}


const api = {
	init: init
};

export default api;